import { useState } from 'react'
import { flexRender } from '@tanstack/react-table'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { cn } from '@/lib/utils'

const TableContent = ({ table, selectedForm, onRowClick, readonly }) => {
    const [hoveredRowId, setHoveredRowId] = useState(null)

    return (
        <Table>
            {/* Table header */}
            <TableHeader>
                {table.getHeaderGroups().map((headerGroup) => (
                    <TableRow key={headerGroup.id} className="tw:h-[50px]">
                        {headerGroup.headers.map((header) => (
                            <TableHead key={header.id}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(header.column.columnDef.header, header.getContext())}
                            </TableHead>
                        ))}
                    </TableRow>
                ))}
            </TableHeader>

            {/* Table body */}
            <TableBody>
                {table.getRowModel().rows?.length ? (
                    table.getRowModel().rows.map((row) => (
                        <TableRow
                            key={row.id}
                            data-state={row.getIsSelected() && 'selected'}
                            className={cn('tw:h-[46px]', { 'selected-row': selectedForm?.id === row.original.id })}
                            onClick={() => onRowClick(row.original)}
                            onMouseEnter={() => setHoveredRowId(row.original.id)}
                            onMouseLeave={() => setHoveredRowId(null)}
                            style={readonly ? { cursor: 'default' } : { cursor: 'pointer' }}
                        >
                            {row.getVisibleCells().map((cell) => (
                                <TableCell key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, {
                                        ...cell.getContext(),
                                        isHovered: hoveredRowId === row.original.id,
                                    })}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))
                ) : (
                    <TableRow>
                        <TableCell colSpan={table.getAllColumns().length} className="tw:h-24 tw:text-center">
                            No results.
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    )
}

export default TableContent
